import React from "react";
import { growthPaths } from "../../../core/data/auditsPage";
import { formatDate } from "../../../core/data/marketOverviewText";
import { INDUSTRY } from "../../../core/theme/auditsTheme";

// "Searches gathered": the running total of completed searches over time.
//   points: the roll-up's searchesOverTime, [{ day, total }]
export default function SearchesGraph({ points }) {
  const paths = growthPaths(points);
  const last = points && points.length > 0 ? points[points.length - 1] : null;

  return (
    <div className={INDUSTRY.graph}>
      <div className={INDUSTRY.label}>Searches gathered</div>
      {paths ? (
        <svg
          viewBox="0 0 300 64" preserveAspectRatio="none" role="img" className={INDUSTRY.graphSvg}
          aria-label={`Searches gathered over time: ${last.total.toLocaleString("en-GB")} by ${formatDate(last.day)}`}
        >
          <path d={paths.area} className={INDUSTRY.graphArea} />
          <path d={paths.line} strokeWidth="2" vectorEffect="non-scaling-stroke" className={INDUSTRY.graphLine} />
        </svg>
      ) : (
        <p className={`${INDUSTRY.note} mt-1.5`}>No completed searches yet.</p>
      )}
    </div>
  );
}
